import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// helpers
import get from 'lodash.get';

function PdpSharedDetailMarkedSize({ item }) {
    const size = get(item, 'measurement.size') || null;

    if (!size) {
        return null;
    }
    return (
        <span data-tn="pdp-spec-marked-size">
            {size.value} {!!size.standard && ` (${size.standard})`}
        </span>
    );
}

PdpSharedDetailMarkedSize.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailMarkedSize, {
    item: graphql`
        fragment PdpSharedDetailMarkedSize_item on Item {
            measurement {
                size {
                    value
                    standard
                }
            }
        }
    `,
});
